import {useOutletContext} from "react-router";
import type {PtV2Summary, PtV2TabKey} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Classes.ts";

/** Shared by the Payment Terms v2 layout with its tab routes. */
export type PtV2OutletContext = {
    summary: PtV2Summary | undefined;
    summaryLoading: boolean;
    summaryError: boolean;
    /** True once workpapers have been synced or imported for this databag. */
    hasData: boolean;
    /** Mithra staff group: sees the Data management section (sync and import). */
    isStaff: boolean;
    tabPath: (tab: PtV2TabKey) => string;
};

export const usePtV2Context = () => useOutletContext<PtV2OutletContext>();

export const PT_V2_TABS: {key: PtV2TabKey; label: string}[] = [
    {key: 'overview', label: 'Overview'},
    {key: 'leakage', label: 'Payment term leakage'},
    {key: 'harmonization', label: 'Term harmonization'},
    {key: 'discounts', label: 'Discount capture'},
    {key: 'actions', label: 'Action plan'},
    {key: 'sources', label: 'Data sources'},
];
